// fix checkout
const handleBSSCheckout = () => {
  BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
};
window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
const handleCartCheckoutBtn = ({ shopData, checkoutButton, Tax }) => {
  const defaultBtnCheckout = $("button[name='checkout']");
  if (defaultBtnCheckout.length > 0) {
    defaultBtnCheckout.css("display", "none");
    $("#bss-checkout").css("display", "block");
  }
};
window.BSS_B2B.addAction("fix_handle_cart_checkout_btn", handleCartCheckoutBtn);

BSS_B2B.customShowPriceQB = (totalPriceHTML, totalPriceItemEle) => {
  $(totalPriceItemEle)
    .closest("tr")
    .find(".cart-item-price2")
    .html(totalPriceHTML);
};

if(BSS_B2B) {
  window.addEventListener("cart_changed", () => {
    setTimeout(() => {
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      BSS_B2B.cart.fixer(storeData, null, false);
      BSS_B2B.handleCartCheckoutBtn(storeData);
    }, 500);
  });
  
}

BSS_B2B.customTriggerCheckoutBtn = (checkoutBtn) => {
  if(!window.location.pathname.includes("/cart")) {
    const defaultCheckoutBtn = document.querySelector('cart-drawer button[name="checkout"]');
    defaultCheckoutBtn.click();
  } else {
    $(checkoutBtn).trigger('click');
  }
  
}